// Generated by CoffeeScript 1.11.1
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('sp/ui/questions/question_view',['require','backbone','jquery','underscore','../templates','./question_form','./question_forms/date_time','./question_forms/essay','./question_forms/form','./question_forms/image','./question_forms/multiple_choice','./question_forms/range','./question_forms/rating','./question_forms/scale','./question_forms/scoring'],function(require) {
  var $, DateTime, Essay, Form, Image, MultipleChoice, QuestionForm, QuestionView, Range, Rating, Scale, Scoring, View, _, questionTemplate;
  View = require('backbone').View;
  $ = require('jquery');
  _ = require('underscore');
  questionTemplate = require('../templates').question;
  QuestionForm = require('./question_form');
  DateTime = require('./question_forms/date_time');
  Essay = require('./question_forms/essay');
  Form = require('./question_forms/form');
  Image = require('./question_forms/image');
  MultipleChoice = require('./question_forms/multiple_choice');
  Range = require('./question_forms/range');
  Rating = require('./question_forms/rating');
  Scale = require('./question_forms/scale');
  Scoring = require('./question_forms/scoring');
  return QuestionView = (function(superClass) {
    extend(QuestionView, superClass);

    function QuestionView() {
      this.formUpdateHandler = bind(this.formUpdateHandler, this);
      this.questionCommentsChangeHandler = bind(this.questionCommentsChangeHandler, this);
      return QuestionView.__super__.constructor.apply(this, arguments);
    }

    QuestionView.NEXT_EVENT = 'next';

    QuestionView.SUBMIT_EVENT = 'submit';

    QuestionView.prototype.tagName = "div";

    QuestionView.prototype.className = "question clearfix";

    QuestionView.prototype.events = {
      "click .next-button": "nextButtonHandler",
      "click .submit-button": "submitButtonHandler",
      "change .question-comments textarea": "questionCommentsChangeHandler"
    };

    QuestionView.prototype.index = 0;

    QuestionView.prototype.total = 0;

    QuestionView.prototype.valid = true;

    QuestionView.prototype.values = null;

    QuestionView.prototype.comments = null;

    QuestionView.prototype.animationSpeed = 250;

    QuestionView.prototype.definitions = null;

    QuestionView.prototype.validationError = null;

    QuestionView.prototype.$validationError = null;

    QuestionView.prototype.answerHandler = function() {};

    QuestionView.prototype.initialize = function(options) {
      var values;
      QuestionView.__super__.initialize.call(this, options);
      return values = [];
    };

    QuestionView.prototype.render = function() {
      var $p, $required, $title, data, template;
      if (this.model.get('required')) {
        this.valid = false;
        if (this.definitions && this.definitions.validations) {
          this.validationError = this.definitions.validations["default"];
        }
      } else {
        this.valid = true;
      }
      data = this.model.toJSON();
      data.index = this.index + 1;
      data.total = this.total;
      data.definitions = this.definitions;
      template = questionTemplate(data);
      this.$el.empty().append(template).attr('id', "question[" + (this.index + 1) + "]");
      $title = this.$el.find('.question-title');
      $title.find('a').attr({
        target: '_blank'
      });
      if (this.model.get('required')) {
        $required = $('<span>').addClass('required').text('*');
        $p = $title.find('p').last();
        if ($p.length) {
          $p.append($required);
        } else {
          $title.append($required);
        }
      }
      if (this.comments) {
        this.$el.find('.question-comments textarea').val(this.comments);
      }
      this.renderQuestionForm();
      return this.$el;
    };

    QuestionView.prototype.renderQuestionForm = function() {
      var $form, FormClass, questionForm;
      if (this.model.get("type")) {
        $form = this.$el.find(".question-form");
        this.$el.attr('class', "question clearfix " + (this.model.get('type').replace('_', '-')) + "-question");
        FormClass = (function() {
          switch (this.model.get("type")) {
            case 'date_time':
              return DateTime;
            case 'essay':
              return Essay;
            case 'form':
              return Form;
            case 'image':
              return Image;
            case 'multiple_choice':
              return MultipleChoice;
            case 'range':
              return Range;
            case 'rating':
              return Rating;
            case 'scale':
              return Scale;
            case 'scoring':
              return Scoring;
          }
        }).call(this);
        questionForm = new FormClass({
          model: this.model
        });
        questionForm.definitions = this.definitions;
        questionForm.on(QuestionForm.UPDATE_EVENT, this.formUpdateHandler);
        $form.html(questionForm.render());
        if (this.values && this.values.length) {
          questionForm.setValues(this.values);
          return this.formUpdateHandler(questionForm);
        }
      }
    };

    QuestionView.prototype.showCompleteMark = function(valid) {
      if (valid == null) {
        valid = this.valid;
      }
      if (this.valid) {
        this.$el.addClass('valid');
        return this.removeValidationError();
      } else {
        return this.$el.removeClass('valid');
      }
    };

    QuestionView.prototype.removeValidationError = function() {
      this.$el.removeClass('invalid');
      if (this.$validationError) {
        this.$validationError.clearQueue().slideUp(300, function() {
          return $(this).remove();
        });
        return this.$validationError = null;
      }
    };

    QuestionView.prototype.showValidationError = function(message, parent) {
      var $msgList;
      if (message == null) {
        message = this.validationError;
      }
      if (message) {
        if (!parent) {
          parent = this.$el.find("hgroup");
        }
        if (_.isArray(message)) {
          $msgList = $("<ul>");
          message.forEach(function(item) {
            return $('<li>').text(item).appendTo($msgList);
          });
        }
        if (this.$validationError) {
          this.$validationError.html($msgList || message).delay(200).animate({
            opacity: 0
          }, 50).animate({
            opacity: 1
          }, 50).animate({
            opacity: 0
          }, 50).animate({
            opacity: 1
          }, 50);
        } else {
          this.$el.addClass('invalid');
          this.$validationError = $("<div>").addClass("error").html($msgList || message).hide().appendTo(parent).delay(250).slideDown(300);
        }
      } else {
        this.removeValidationError();
      }
      return message && message.length;
    };

    QuestionView.prototype.out = function(destroyOnComplete, callback) {
      var $stage, stageWidth, xPos;
      if (destroyOnComplete == null) {
        destroyOnComplete = false;
      }
      $stage = $('body');
      stageWidth = $stage.outerWidth();
      xPos = -this.$el.outerWidth();
      return this.$el.animate({
        left: xPos,
        opacity: 0
      }, this.animationSpeed, (function(_this) {
        return function() {
          if (destroyOnComplete) {
            _this.destroy();
          }
          if (callback) {
            return callback();
          }
        };
      })(this));
    };

    QuestionView.prototype["in"] = function(callback) {
      if (callback == null) {
        callback = function() {};
      }
      return this.center(true, callback);
    };

    QuestionView.prototype.center = function(animate, callback) {
      var $stage, hCenter, stageWidth;
      if (animate == null) {
        animate = false;
      }
      if (callback == null) {
        callback = function() {};
      }
      $stage = $('#survey-container');
      if (!$stage.offset()) {
        return callback();
      }
      stageWidth = $stage.outerWidth();
      hCenter = Math.round((stageWidth * .5 - this.$el.outerWidth() * .5) + $stage.offset().left);
      if (animate) {
        return this.$el.stop().css({
          "position": 'absolute',
          "left": stageWidth + 50,
          "opacity": 0,
          "display": "block"
        }).delay(250).animate({
          left: hCenter,
          opacity: 100
        }, this.animationSpeed, 'easeOutSine', callback);
      } else {
        this.$el.stop().css({
          "position": 'absolute',
          "left": hCenter,
          "opacity": 1,
          "display": "block",
          "z-index": this.index
        });
        return callback();
      }
    };

    QuestionView.prototype.destroy = function(fadeOut) {
      if (fadeOut == null) {
        fadeOut = false;
      }
      this.$el.unbind();
      if (fadeOut) {
        return this.$el.fadeOut((function(_this) {
          return function() {
            return _this.$el.remove();
          };
        })(this));
      } else {
        return this.$el.remove();
      }
    };

    QuestionView.prototype.questionCommentsChangeHandler = function(e) {
      this.comments = e.target.value;
      return this.trigger(QuestionForm.UPDATE_EVENT, this);
    };

    QuestionView.prototype.formUpdateHandler = function(form) {
      this.validationError = form.validate();
      this.valid = this.validationError && this.validationError.length ? false : true;
      this.values = form.values;
      this.showCompleteMark();
      return this.trigger(QuestionForm.UPDATE_EVENT, this);
    };

    QuestionView.prototype.nextButtonHandler = _.debounce(function(e) {
      e.preventDefault();
      if (this.valid) {
        return this.trigger(QuestionView.NEXT_EVENT, e, this);
      } else {
        return this.showValidationError();
      }
    }, 500, {
      leading: true,
      trailing: false
    });

    QuestionView.prototype.submitButtonHandler = _.debounce(function(e) {
      e.preventDefault();
      if (this.valid) {
        return this.trigger(QuestionView.SUBMIT_EVENT, e, this);
      } else {
        return this.showValidationError();
      }
    }, 500, {
      leading: true,
      trailing: false
    });

    return QuestionView;

  })(View);
});

